import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

// In-app notifications were seeded with `/orders/{id}` and the order page is
// `/order-management/orders/{id}` (ADR-0036). The templates are repointed by a
// migration, but the notifications already delivered keep the link they were
// written with, so the old path keeps working instead of landing on the 404.
const LegacyOrderRedirect = () => {
    const { id } = useParams();
    const { hash } = useLocation();
    return <Navigate to={`/order-management/orders/${id}${hash || ''}`} replace />;
};

export default LegacyOrderRedirect;
